// extracted by mini-css-extract-plugin
module.exports = {"container_comment":"comments_container_comment__3OOdB","comment":"comments_comment__4V7Wd","container_infos":"comments_container_infos__27hm7","date":"comments_date__AuQwp"};